import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import FrameworkUtils from 'utils/framework';
import ShipAddressSection from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/Section/ShipAddressSection';
import OrderActions from 'actions/OrderActions';
import SampleActions from 'actions/SampleActions';
import store from 'store/Store';
import Location from 'utils/Location';
import { refreshCheckout, setAccessPoint as setAccessPointFromModal } from 'services/Checkout';
import checkoutUtils from 'utils/Checkout';
import orderUtils from 'utils/Order';
const { isHalAddress } = orderUtils;
import ShipAddressEN from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/locales/ShipAddress_en_US';
import ShipAddressFR from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/locales/ShipAddress_fr_CA';
import { orderSelector } from 'selectors/order/orderSelector';
import { orderDetailsSelector } from 'selectors/order/orderDetails/orderDetailsSelector';

const addressNeedsConfirmationSelector = createSelector(orderSelector, order => order.addressNeedsToBeConfirmed || false);
const giftAddressNeedsConfirmationSelector = createSelector(orderSelector, order => order.giftCardAddressNeedsToBeConfirmed || false);

const saveAddress = (comp, clearErrors) => {
    store.dispatch(OrderActions.sectionSaved(Location.getLocation().pathname, comp, false));
    refreshCheckout({ clearErrors })().then(() => {
        comp.props.setAccessPoint(false);
        checkoutUtils.changeCheckoutUrlBasedOnOrderCompleteness(false, false, false);
        checkoutUtils.checkAndOrderCreditCardsUpdate();
    });
};

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource, isCanada } = LanguageLocaleUtils;

const getText = getLocalisedDataFromResource(ShipAddressEN, ShipAddressFR);

const textResources = createStructuredSelector({
    removeAddressLabel: getTextFromResource(getText, 'removeAddressLabel'),
    remove: getTextFromResource(getText, 'remove'),
    editAddressLabel: getTextFromResource(getText, 'editAddressLabel'),
    edit: getTextFromResource(getText, 'edit'),
    addShippingAddress: getTextFromResource(getText, 'addShippingAddress'),
    showMoreAddresses: getTextFromResource(getText, 'showMoreAddresses'),
    showLessAddresses: getTextFromResource(getText, 'showLessAddresses'),
    deliveryMethod: getTextFromResource(getText, 'deliveryMethod'),
    setAsDefaultCheckbox: getTextFromResource(getText, 'setAsDefaultCheckbox'),
    editShipAddress: getTextFromResource(getText, 'editShipAddress'),
    addNewShipAddress: getTextFromResource(getText, 'addNewShipAddress'),
    cancelButton: getTextFromResource(getText, 'cancelButton'),
    continueButton: getTextFromResource(getText, 'continueButton'),
    areYouSureMessage: getTextFromResource(getText, 'areYouSureMessage'),
    taxExemptAddressLabel: getTextFromResource(getText, 'taxExemptAddressLabel'),
    shippingMessage: getTextFromResource(getText, 'shippingMessage'),
    maximumAddressesReached: getTextFromResource(getText, 'maximumAddressesReached'),
    deleteSavedAddresses: getTextFromResource(getText, 'deleteSavedAddresses'),
    ok: getTextFromResource(getText, 'ok'),
    removeAddress: getTextFromResource(getText, 'removeAddress'),
    useThisAddress: getTextFromResource(getText, 'useThisAddress'),
    fedexPickupLabel: getTextFromResource(getText, 'fedexPickupLabel'),
    pickupLabelCA: getTextFromResource(getText, 'pickupLabelCA')
});

const functions = {
    setCheckoutSectionErrors: OrderActions.setCheckoutSectionErrors,
    clearNamedSectionErrors: OrderActions.clearNamedSectionErrors,
    setAddressNeedsConfirmation: OrderActions.setAddressNeedsConfirmation,
    setGiftCardAddressNeedsConfirmation: OrderActions.setGiftCardAddressNeedsConfirmation,
    fetchSamples: SampleActions.fetchSamples
};

const connectedShipAddress = connect(
    createSelector(
        textResources,
        addressNeedsConfirmationSelector,
        giftAddressNeedsConfirmationSelector,
        orderDetailsSelector,
        (texts, addressNeedsConfirmation, giftAddressNeedsConfirmation, orderDetails) => {
            const isCa = isCanada();

            return {
                ...texts,
                pickupLabel: isCa ? texts.pickupLabelCA : texts.fedexPickupLabel,
                getText,
                saveAddress,
                isHalAddress,
                setAccessPointFromModal,
                addressNeedsConfirmation,
                giftAddressNeedsConfirmation,
                orderItems: orderDetails?.items?.items
            };
        }
    ),
    functions
);

const withComponentProps = wrapHOC(connectedShipAddress);

export default withComponentProps(ShipAddressSection);
